import axios from "axios";
import { useEffect } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const WA_NUMBER = "905437787573";
export function waLink(text = "Merhaba, Ada Özel Güvenlik Eğitim Kurumu hakkında bilgi almak istiyorum.", number = WA_NUMBER) {
  const t = encodeURIComponent(text);
  const mobile = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
  return mobile ? `https://wa.me/${number}?text=${t}` : `https://web.whatsapp.com/send?phone=${number}&text=${t}`;
}

export const EVENT_TYPES = {
  temel: "Temel Eğitim", yenileme: "Yenileme Eğitimi", silah_farki: "Silah Farkı", sinav: "Sınav",
  son_basvuru: "Başvuru Son Tarihi", atis: "Atış / Uygulama", duyuru: "Kurum Duyurusu",
};
export const QUESTION_CATS = {
  hukuk: "Özel güvenlik hukuku ve mevzuatı", guvenlik_tedbirleri: "Güvenlik tedbirleri", kisi_koruma: "Kişi koruma",
  guvenlik_sistemleri: "Güvenlik sistemleri", ilk_yardim: "İlk yardım", yangin: "Yangın güvenliği", iletisim: "Etkili iletişim",
  kalabalik: "Kalabalık yönetimi", olay_yeri: "Olay yeri ve genel uygulamalar", silah: "Silah bilgisi ve güvenli kullanım", diger: "Diğer",
};
export const VIDEO_CATS = {
  temel_dersler: "Özel güvenlik temel dersleri", mevzuat: "Mevzuat", uygulamalar: "Güvenlik uygulamaları", ilk_yardim: "İlk yardım",
  yangin: "Yangın güvenliği", iletisim_kalabalik: "İletişim ve kalabalık yönetimi", silah: "Silah bilgisi ve uygulamalı eğitimler",
  sinav_hazirlik: "Sınav hazırlık videoları", egitmen: "Eğitmen anlatımları",
};
export const POST_CATS = {
  kurs_kayit: "Kurs kayıt duyuruları", sinav: "Sınav duyuruları", programlar: "Eğitim programları",
  mevzuat_degisiklik: "Mevzuat değişiklikleri", bilgilendirme: "Kursiyer bilgilendirmeleri", kurumsal: "Kurumsal haberler",
  mevzuat: "Mevzuat rehberi", meslek: "Meslek rehberi",
};
export const APP_STATUS = {
  yeni: "Yeni başvuru", iletisim_kurulacak: "İletişim kurulacak", gorusme_yapildi: "Görüşme yapıldı", evrak_bekleniyor: "Evrak bekleniyor",
  kayit_davet: "Kayıt için davet edildi", kayit_tamamlandi: "Kayıt tamamlandı", iptal: "İptal edildi",
};
export const PAY_STATUS = { bekleniyor: "Ödeme bekleniyor", kismi: "Kısmi ödeme", tamamlandi: "Ödeme tamamlandı", iade_iptal: "İade / iptal" };

export const fmtDate = (s) => (s ? new Date(s.length <= 10 ? s + "T00:00:00" : s).toLocaleDateString("tr-TR", { day: "2-digit", month: "long", year: "numeric" }) : "");

export function useSeo(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | Ada Özel Güvenlik Eğitim Kurumu` : "Ada Özel Güvenlik Eğitim Kurumu | Kuşadası Özel Güvenlik Kursu";
    const setMeta = (sel, attr, val) => {
      let el = document.head.querySelector(sel);
      if (!el) {
        el = document.createElement(sel.startsWith("link") ? "link" : "meta");
        if (sel.startsWith("link")) el.rel = "canonical";
        else el.setAttribute(sel.includes("property") ? "property" : "name", sel.match(/"(.+)"/)[1]);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, val);
    };
    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
    }
    setMeta('meta[property="og:title"]', "content", document.title);
    setMeta('link[rel="canonical"]', "href", window.location.origin + window.location.pathname);
  }, [title, description]);
}

export const safeUrl = (u) => (typeof u === "string" && /^(https?:|mailto:|tel:)/i.test(u.trim()) ? u : undefined);

export function embedUrl(url = "") {
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
  if (yt) return `https://www.youtube-nocookie.com/embed/${yt[1]}?rel=0`;
  const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return url.startsWith("https://") ? url : "";
}

export function icsDownload(ev) {
  const d = (s) => (s || "").replaceAll("-", "");
  const end = ev.end_date || ev.start_date;
  const next = new Date(end + "T00:00:00");
  next.setDate(next.getDate() + 1);
  const ics = ["BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Ada Ozel Guvenlik//TR", "BEGIN:VEVENT", `UID:${ev.id}@ada`,
    `DTSTART;VALUE=DATE:${d(ev.start_date)}`, `DTEND;VALUE=DATE:${next.toISOString().slice(0, 10).replaceAll("-", "")}`,
    `SUMMARY:${ev.title}`, `DESCRIPTION:${(ev.description || "").replace(/\n/g, " ")}`,
    "LOCATION:Ada Özel Güvenlik Eğitim Kurumu, Kuşadası / Aydın", "END:VEVENT", "END:VCALENDAR"].join("\r\n");
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([ics], { type: "text/calendar" }));
  a.download = `${ev.title}.ics`;
  a.click();
}
